// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1800px) {
  .dash_user_sec {
    flex-wrap: nowrap;
  }
}

@media (max-width: 1600px) {
  .owner_login {
    height: auto;
  }
  .right-side {
    height: auto;
  }
}

@media (max-width: 1199.98px) {
  .owner_login {
    height: auto;
  }
  .right-side {
    height: auto;
  }
}

@media (max-width: 991.98px) {
  .owner_login {
    display: flex;
    flex-direction: column;
    height: auto;
  }
  .left-side,
  .right-side {
    width: 100%;
  }
  .left_content {
    padding: 20px;
  }
  /* add some css make for responsive seema*/
  .active_header {
    display: flex !important;
    flex-direction: row;
    height: unset !important;
    justify-content: space-between;
    width: 100% !important;
    padding: 10px !important;
  }
  .notification-wrapper {
    position: relative;
    display: flex;
    flex-direction: row !important;
    min-width: 100px;
    align-items: center;
    gap: 5px;
  }
  .navbar-nav .dropdown-menu {
    position: absolute !important;
  }
  .dropdown-menu.show {
    top: 0;
    left: 0;
    transform: translate(-60%, 0%);
    min-height: 40px !important;
    min-width: 86px !important;
  }
}

@media (max-width: 767.98px) {
  .login_wrap {
    max-width: 100%;
    min-height: auto;
    display: flex;
    flex-direction: column;
  }
  .login_content {
    max-width: 100%;
    width: 100%;
    border-left: 0;
    padding: 10px;
  }
}

@media (max-width: 575.98px) {
  .heading_content h3 {
    font-size: 18px;
  }
  .name_account .form-label {
    font-size: 18px;
  }
  .item_box p {
    font-size: 14px;
  }
  .item_box.active,
  .item_box:hover {
    padding: 10px;
  }
  .profile__tab {
    margin-bottom: 20px;
  }
  .profile__tab .nav-pills a {
    max-width: 100%;
  }
  .profile__content {
    padding: 0px 10px;
  }
  .search-wrapper h3 {
    font-size: 15px !important;
  }
}

/* add new css @responsive after testing 26-02*/
@media (max-width: 767px) {
  .login-paragraph {
    margin-top: 30px;
    font-size: 10px !important;
  }

  .owner_logo {
    display: flex;
    justify-content: space-around;
  }

  .card_single {
    max-width: none;
  }
}

@media (max-width: 991px) {
  .owner_logo {
    display: flex;
    justify-content: space-around;
  }

  .login-p-tag {
    display: none;
  }
  /* . {
    left: -100%;
  } */
  .sidebar {
    position: fixed !important;
    left: 0px;
    display: block !important;
    z-index: 9999;
    width: auto !important;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

  .hidden {
    width: 0px !important;
    left: -100px;
    position: absolute !important;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1280px) {
  .welcome_text p {
    font-size: 30px;
  }
}

@media only screen and (min-width: 767px) and (max-width: 920px) {
  .btns_sec .form-select {
    min-width: 100px;
  }
  .btn_export {
    min-width: 100px !important;
  }
}
/* Media query for screens between 320px and 425px */
@media (max-width: 425px) {
  .left-side {
    display: none;
  }
}

/* Responsive Styling for Screens Between 376px and 761px */
@media only screen and (min-width: 369px) and (max-width: 861px) {
  .direction {
    flex-direction: column;
  }
}

@media only screen and (min-width: 310px) and (max-width: 535px) {
  .btns_sec .form-select {
    min-width: 87px;
    margin: 4px !important;
  }
}

@media only screen and (min-width: 310px) and (max-width: 991px) {
  .search_table {
    flex-direction: column;
    margin-bottom: 10px !important;
  }
}

@media only screen and (min-width: 310px) and (max-width: 991px) {
  .booking-details .modal-content {
    min-width: 0 !important;
  }

  .modal-genrate .modal-content {
    min-width: 0 !important;
  }

  .modal-report .modal-content {
    min-width: 0 !important;
  }

  .res_generate {
    width: 100% !important;
  }
  /*remove .search_table seema*/

  .search_table svg {
    margin-top: 10px !important;
  }
}
@media only screen and (min-width: 310px) and (max-width: 1024px) {
  .profile_content_inputfield {
    min-width: 0 !important;
  }
}
@media only screen and (min-width: 310px) and (max-width: 991px) {
  .admin_toggle {
    display: none !important;
  }
}
/* add some css make for responsive seema*/
@media only screen and (min-width: 310px) and (max-width: 525px) {
  .direction_f {
    flex-direction: column;
  }
  .gen_btn {
    width: 100% !important;
  }
  .search_table svg {
    margin-top: 10px !important;
  }
}
@media only screen and (min-width: 310px) and (max-width: 425px) {
  select.form-select {
    width: 100% !important;
  }
}
@media only screen and (min-width: 310px) and (max-width: 991px) {
  .gen_btn {
    width: 100% !important;
  }
}

@media only screen and (min-width: 310px) and (max-width: 425px) {
  .btns_sec {
    gap: 4px !important;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 8px !important;
  }
  .date-picker-container {
    margin: 4px !important;
  }
  .form_f {
    margin: 4px;
    width: 100%;
  }
  .align-items-baseline {
    margin: 4px !important;
    width: 100% !important;
    padding-top: 5px !important;
  }
}

@media only screen and (min-width: 310px) and (max-width: 1024px) {
  .btns_sec {
    gap: 4px !important;
    display: flex;
    align-items: center;
    /* flex-wrap: wrap; */
    padding-top: 5px !important;
  }
}
@media only screen and (min-width: 767px) and (max-width: 1024px) {
  .search_landload {
    min-width: 190px !important;
  }
  .texts-p {
    font-size: 15px;
    line-height: 24px;
    font-weight: 600;
  }
}
@media only screen and (min-width: 310px) and (max-width: 1024px) {
  .dimens-p {
    flex-direction: row !important;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .fac_manage {
    flex-wrap: wrap !important;
    gap: 20px !important;
  }
  .facility_searchs {
    flex-direction: row !important;
    width: 100%;
    justify-content: space-evenly;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1440px) {
  .work__order__request_wrap ul li {
    display: flex;
    border-bottom: 1px solid #e9ecef;
    padding-bottom: 10px;
    margin-bottom: 15px;
    flex-wrap: nowrap !important;
  }
  .date_facility {
    max-width: 108px;
  }
}
/* // * add some css fix issues */
@media only screen and (min-width: 768px) and (max-width: 800px) {
  .date-picker-icon {
    position: relative;
    right: 22px;
  }
  .date_facility {
    width: 145%;
  }
}

@media only screen and (min-width: 768px) and (max-width: 800px) {
  .newdatepicker {
    position: relative;
    right: -1px;
  }
}
.date_facility {
  max-width: 108px;
}
`, "",{"version":3,"sources":["webpack://./src/components/customerpenal/styles/customer-responsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;EACA;;IAEE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA,0CAA0C;EAC1C;IACE,wBAAwB;IACxB,mBAAmB;IACnB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,MAAM;IACN,OAAO;IACP,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,WAAW;IACX,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;EACA;;KAEG;EACH;IACE,0BAA0B;IAC1B,SAAS;IACT,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,4EAA4E;EAC9E;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;AACF;AACA,oDAAoD;AACpD;EACE;IACE,aAAa;EACf;AACF;;AAEA,2DAA2D;AAC3D;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;EACA,6BAA6B;;EAE7B;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA,0CAA0C;AAC1C;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;EACA;IACE,8BAA8B;IAC9B,WAAW;IACX,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,aAAa;IACb,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;IACnB,4BAA4B;EAC9B;EACA;IACE,gBAAgB;EAClB;AACF;AACA,iCAAiC;AACjC;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@media (min-width: 1800px) {\n  .dash_user_sec {\n    flex-wrap: nowrap;\n  }\n}\n\n@media (max-width: 1600px) {\n  .owner_login {\n    height: auto;\n  }\n  .right-side {\n    height: auto;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .owner_login {\n    height: auto;\n  }\n  .right-side {\n    height: auto;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .owner_login {\n    display: flex;\n    flex-direction: column;\n    height: auto;\n  }\n  .left-side,\n  .right-side {\n    width: 100%;\n  }\n  .left_content {\n    padding: 20px;\n  }\n  /* add some css make for responsive seema*/\n  .active_header {\n    display: flex !important;\n    flex-direction: row;\n    height: unset !important;\n    justify-content: space-between;\n    width: 100% !important;\n    padding: 10px !important;\n  }\n  .notification-wrapper {\n    position: relative;\n    display: flex;\n    flex-direction: row !important;\n    min-width: 100px;\n    align-items: center;\n    gap: 5px;\n  }\n  .navbar-nav .dropdown-menu {\n    position: absolute !important;\n  }\n  .dropdown-menu.show {\n    top: 0;\n    left: 0;\n    transform: translate(-60%, 0%);\n    min-height: 40px !important;\n    min-width: 86px !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .login_wrap {\n    max-width: 100%;\n    min-height: auto;\n    display: flex;\n    flex-direction: column;\n  }\n  .login_content {\n    max-width: 100%;\n    width: 100%;\n    border-left: 0;\n    padding: 10px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .heading_content h3 {\n    font-size: 18px;\n  }\n  .name_account .form-label {\n    font-size: 18px;\n  }\n  .item_box p {\n    font-size: 14px;\n  }\n  .item_box.active,\n  .item_box:hover {\n    padding: 10px;\n  }\n  .profile__tab {\n    margin-bottom: 20px;\n  }\n  .profile__tab .nav-pills a {\n    max-width: 100%;\n  }\n  .profile__content {\n    padding: 0px 10px;\n  }\n  .search-wrapper h3 {\n    font-size: 15px !important;\n  }\n}\n\n/* add new css @responsive after testing 26-02*/\n@media (max-width: 767px) {\n  .login-paragraph {\n    margin-top: 30px;\n    font-size: 10px !important;\n  }\n\n  .owner_logo {\n    display: flex;\n    justify-content: space-around;\n  }\n\n  .card_single {\n    max-width: none;\n  }\n}\n\n@media (max-width: 991px) {\n  .owner_logo {\n    display: flex;\n    justify-content: space-around;\n  }\n\n  .login-p-tag {\n    display: none;\n  }\n  /* . {\n    left: -100%;\n  } */\n  .sidebar {\n    position: fixed !important;\n    left: 0px;\n    display: block !important;\n    z-index: 9999;\n    width: auto !important;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  }\n\n  .hidden {\n    width: 0px !important;\n    left: -100px;\n    position: absolute !important;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1280px) {\n  .welcome_text p {\n    font-size: 30px;\n  }\n}\n\n@media only screen and (min-width: 767px) and (max-width: 920px) {\n  .btns_sec .form-select {\n    min-width: 100px;\n  }\n  .btn_export {\n    min-width: 100px !important;\n  }\n}\n/* Media query for screens between 320px and 425px */\n@media (max-width: 425px) {\n  .left-side {\n    display: none;\n  }\n}\n\n/* Responsive Styling for Screens Between 376px and 761px */\n@media only screen and (min-width: 369px) and (max-width: 861px) {\n  .direction {\n    flex-direction: column;\n  }\n}\n\n@media only screen and (min-width: 310px) and (max-width: 535px) {\n  .btns_sec .form-select {\n    min-width: 87px;\n    margin: 4px !important;\n  }\n}\n\n@media only screen and (min-width: 310px) and (max-width: 991px) {\n  .search_table {\n    flex-direction: column;\n    margin-bottom: 10px !important;\n  }\n}\n\n@media only screen and (min-width: 310px) and (max-width: 991px) {\n  .booking-details .modal-content {\n    min-width: 0 !important;\n  }\n\n  .modal-genrate .modal-content {\n    min-width: 0 !important;\n  }\n\n  .modal-report .modal-content {\n    min-width: 0 !important;\n  }\n\n  .res_generate {\n    width: 100% !important;\n  }\n  /*remove .search_table seema*/\n\n  .search_table svg {\n    margin-top: 10px !important;\n  }\n}\n@media only screen and (min-width: 310px) and (max-width: 1024px) {\n  .profile_content_inputfield {\n    min-width: 0 !important;\n  }\n}\n@media only screen and (min-width: 310px) and (max-width: 991px) {\n  .admin_toggle {\n    display: none !important;\n  }\n}\n/* add some css make for responsive seema*/\n@media only screen and (min-width: 310px) and (max-width: 525px) {\n  .direction_f {\n    flex-direction: column;\n  }\n  .gen_btn {\n    width: 100% !important;\n  }\n  .search_table svg {\n    margin-top: 10px !important;\n  }\n}\n@media only screen and (min-width: 310px) and (max-width: 425px) {\n  select.form-select {\n    width: 100% !important;\n  }\n}\n@media only screen and (min-width: 310px) and (max-width: 991px) {\n  .gen_btn {\n    width: 100% !important;\n  }\n}\n\n@media only screen and (min-width: 310px) and (max-width: 425px) {\n  .btns_sec {\n    gap: 4px !important;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    padding-top: 8px !important;\n  }\n  .date-picker-container {\n    margin: 4px !important;\n  }\n  .form_f {\n    margin: 4px;\n    width: 100%;\n  }\n  .align-items-baseline {\n    margin: 4px !important;\n    width: 100% !important;\n    padding-top: 5px !important;\n  }\n}\n\n@media only screen and (min-width: 310px) and (max-width: 1024px) {\n  .btns_sec {\n    gap: 4px !important;\n    display: flex;\n    align-items: center;\n    /* flex-wrap: wrap; */\n    padding-top: 5px !important;\n  }\n}\n@media only screen and (min-width: 767px) and (max-width: 1024px) {\n  .search_landload {\n    min-width: 190px !important;\n  }\n  .texts-p {\n    font-size: 15px;\n    line-height: 24px;\n    font-weight: 600;\n  }\n}\n@media only screen and (min-width: 310px) and (max-width: 1024px) {\n  .dimens-p {\n    flex-direction: row !important;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .fac_manage {\n    flex-wrap: wrap !important;\n    gap: 20px !important;\n  }\n  .facility_searchs {\n    flex-direction: row !important;\n    width: 100%;\n    justify-content: space-evenly;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 1440px) {\n  .work__order__request_wrap ul li {\n    display: flex;\n    border-bottom: 1px solid #e9ecef;\n    padding-bottom: 10px;\n    margin-bottom: 15px;\n    flex-wrap: nowrap !important;\n  }\n  .date_facility {\n    max-width: 108px;\n  }\n}\n/* // * add some css fix issues */\n@media only screen and (min-width: 768px) and (max-width: 800px) {\n  .date-picker-icon {\n    position: relative;\n    right: 22px;\n  }\n  .date_facility {\n    width: 145%;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 800px) {\n  .newdatepicker {\n    position: relative;\n    right: -1px;\n  }\n}\n.date_facility {\n  max-width: 108px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
